// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-input-company {
  width: 100%;
  max-width: 343px;
  min-height: 82px;
  box-shadow: 0 2px 4px 0 rgba(20, 46, 82, 0.2);
  padding: 1px;
  border-radius: 4px;
  overflow: hidden;
  background: var(--sebrae-light-gray5);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.3s ease-in-out;
}
.card-input-company .wrapper {
  display: block;
  width: 100%;
  height: 100%;
  border-radius: 4px;
  padding: 12px 14px;
  cursor: pointer;
  background: var(--sebrae-white);
}
.card-input-company .company__radio {
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: 10px;
}
.card-input-company .company__radio__data {
  display: flex;
  gap: 10px;
  padding-top: 4px;
}
.card-input-company .company__radio__checkbox {
  width: 20px;
  height: 20px;
  min-width: 20px;
  border-radius: 100%;
  background: var(--sebrae-white);
  border: 2px solid var(--sebrae-light-gray5);
  transition: all 255ms cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.card-input-company .company__radio__checkbox svg {
  color: var(--sebrae-white);
  display: none;
  width: 20px;
}
.card-input-company .company-name {
  font-size: 11px;
  line-height: 1.2;
  margin-bottom: 2px;
}
.card-input-company small {
  display: block;
  font-size: 11px;
  line-height: 1.2;
}
.card-input-company .BaSe--checkbox {
  width: 20px;
  height: 20px;
  min-height: 20px;
}
.card-input-company .BaSe--checkbox div {
  width: 100%;
  height: 100%;
}
.card-input-company .BaSe--checkbox div:last-child {
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.card-input-company .BaSe--checkbox div:last-child img {
  width: 20px;
  height: 20px;
}
.card-input-company.active {
  padding: 1px;
  background: linear-gradient(45deg, #3B4AFF 0%, #40BBFF 100%);
}
.card-input-company.active .company__radio__checkbox {
  border-color: var(--sebrae-blue-6);
  background: var(--sebrae-blue-6);
}
.card-input-company.active .company__radio__checkbox svg {
  display: block;
}
@media screen and (min-width: 375px) {
  .card-input-company .company-name {
    font-size: 13px;
  }
}
@media screen and (min-width: 1025px) {
  .card-input-company:hover {
    padding: 1px;
    background: linear-gradient(45deg, #3B4AFF 0%, #40BBFF 100%);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/cards/card-input-company/index.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,6CAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,qCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uCAAA;AACF;AACE;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,+BAAA;AACJ;AACE;EACE,WAAA;EACA,aAAA;EACA,8BAAA;EACA,SAAA;AACJ;AACI;EACE,aAAA;EACA,SAAA;EACA,gBAAA;AACN;AACI;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,+BAAA;EACA,2CAAA;EACA,kDAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AACN;AACM;EACE,0BAAA;EACA,aAAA;EACA,WAAA;AACR;AAGE;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;AADJ;AAGE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AADJ;AAGE;EACE,WAAA;EACA,YAAA;EACA,gBAAA;AADJ;AAGI;EACE,WAAA;EACA,YAAA;AADN;AAGM;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AADR;AAGQ;EACE,WAAA;EACA,YAAA;AADV;AAOE;EACE,YAAA;EACA,4DAAA;AALJ;AAOI;EACE,kCAAA;EACA,gCAAA;AALN;AAOM;EACE,cAAA;AALR;AAUE;EACE;IACE,eAAA;EARJ;AACF;AAUE;EACE;IACE,YAAA;IACA,4DAAA;EARJ;AACF","sourcesContent":[".card-input-company {\n  width: 100%;\n  max-width: 343px;\n  min-height: 82px;\n  box-shadow: 0 2px 4px 0 rgba(20, 46, 82, 0.20);\n  padding: 1px;\n  border-radius: 4px;\n  overflow: hidden;\n  background: var(--sebrae-light-gray5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background .3s ease-in-out;\n\n  .wrapper {\n    display: block;\n    width: 100%;\n    height: 100%;\n    border-radius: 4px;\n    padding: 12px 14px;\n    cursor: pointer;\n    background: var(--sebrae-white);\n  }\n  .company__radio {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    gap: 10px;\n\n    &__data {\n      display: flex;\n      gap: 10px;\n      padding-top: 4px;\n    }\n    &__checkbox {\n      width: 20px;\n      height: 20px;\n      min-width: 20px;\n      border-radius: 100%;\n      background: var(--sebrae-white);\n      border: 2px solid var(--sebrae-light-gray5);\n      transition: all 255ms cubic-bezier(0.4, 0, 0.2, 1);\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      overflow: hidden;\n\n      svg {\n        color: var(--sebrae-white);\n        display: none;\n        width: 20px;\n      }\n    }\n  }\n  .company-name {\n    font-size: 11px;\n    line-height: 1.2;\n    margin-bottom: 2px;\n  }\n  small {\n    display: block;\n    font-size: 11px;\n    line-height: 1.2;\n  }\n  .BaSe--checkbox {\n    width: 20px;\n    height: 20px;\n    min-height: 20px;\n\n    div {\n      width: 100%;\n      height: 100%;\n\n      &:last-child {\n        width: 20px;\n        height: 20px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n\n        img {\n          width: 20px;\n          height: 20px;\n        }\n      }\n    }\n  }\n\n  &.active {\n    padding: 1px;\n    background: linear-gradient(45deg, #3B4AFF 0%, #40BBFF 100%);\n\n    .company__radio__checkbox {\n      border-color: var(--sebrae-blue-6);\n      background: var(--sebrae-blue-6);\n\n      svg {\n        display: block;\n      }\n    }\n  }\n\n  @media screen and (min-width: 375px) {\n    .company-name {\n      font-size: 13px;\n    }\n  }\n  @media screen and (min-width: 1025px) {\n    &:hover {\n      padding: 1px;\n      background: linear-gradient(45deg, #3B4AFF 0%, #40BBFF 100%);\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
